"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertIcon = AlertIcon;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactSpring = require("react-spring");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function AlertIcon(type) {
  switch (type) {
    case 'success':
      return /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--md",
        name: "check-circle-fill",
        fill: _constants.COLORS.SUCCESS
      });
    case 'error':
      return /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--md",
        name: "alert-fill",
        fill: _constants.COLORS.ERROR
      });
    case 'info':
      return /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--md",
        name: "info-i-fill",
        fill: _constants.COLORS.PRIMARY
      });
    case 'warning':
      return /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--md",
        name: "alert-fill",
        fill: _constants.COLORS.WARNING
      });
    case 'hot':
      return /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--md",
        name: "flame",
        fill: _constants.COLORS.WARNING
      });
    default:
      return /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        className: "icon--md",
        name: "alert-fill",
        fill: _constants.COLORS.WARNING
      });
  }
}
function Alert(_ref) {
  var title = _ref.title,
    text = _ref.text,
    cta = _ref.cta,
    type = _ref.type,
    show = _ref.show,
    style = _ref.style,
    onClose = _ref.onClose,
    children = _ref.children,
    className = _ref.className,
    disableTransition = _ref.disableTransition;
  var transitions = (0, _reactSpring.useTransition)(show, {
    from: {
      opacity: 0,
      bgOpacity: 0,
      x: 50
    },
    enter: {
      opacity: 1,
      bgOpacity: 0.5,
      x: 0
    },
    leave: {
      opacity: 0,
      bgOpacity: 0,
      x: 50
    }
  });
  function handleCloseAlert() {
    onClose();
  }
  if (disableTransition) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      role: "alert",
      className: (0, _classnames["default"])('d8-c-alert', 'd8-u-component-padding', 'd8-u-radius-md', type ? "alert-".concat(type) : 'alert-default', className),
      style: _objectSpread({}, style)
    }, !text ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert-message text-component"
    }, children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert-icon flex"
    }, AlertIcon(type)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert-message text-component"
    }, title && /*#__PURE__*/_react["default"].createElement("h2", {
      className: "text-md"
    }, title), /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-text-semi-bold"
    }, text), cta && /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-top-xs"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      text: cta.text,
      link: cta.link,
      buttonType: cta.buttonType,
      external: cta.external,
      onClick: cta.onClick
    }))), onClose && /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert-close-button-container"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      type: "button-close",
      className: "alert-button close-button flex",
      onClick: handleCloseAlert
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: "icon--sm",
      name: "cross"
    })))));
  }
  return transitions(function (transitionStyles, item) {
    return item && /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
      style: _objectSpread(_objectSpread({}, style), {}, {
        transform: transitionStyles.x.to(function (x) {
          return "translate3d(".concat(x, "px, 0, 0)");
        })
      }, transitionStyles),
      role: "alert",
      className: (0, _classnames["default"])('d8-c-alert', 'd8-u-component-padding', 'd8-u-radius-md', type ? "alert-".concat(type) : 'alert-default', className)
    }, !text ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert-message text-component"
    }, children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert-icon flex"
    }, AlertIcon(type)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert-message text-component"
    }, title && /*#__PURE__*/_react["default"].createElement("h2", {
      className: "text-md"
    }, title), /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-text-semi-bold"
    }, typeof text === 'function' ? text() : text), cta && /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-top-xs"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      text: cta.text,
      link: cta.link,
      buttonType: cta.buttonType,
      external: cta.external,
      onClick: cta.onClick
    }))), onClose && /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert-close-button-container"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      type: "button-close",
      className: "alert-button close-button flex",
      onClick: handleCloseAlert
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: "icon--sm",
      name: "cross"
    })))));
  });
}
Alert.propTypes = {
  title: _propTypes["default"].string,
  text: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].string]),
  cta: _propTypes["default"].object,
  type: _propTypes["default"].string,
  show: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  onClose: _propTypes["default"].func,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  className: _propTypes["default"].string,
  disableTransition: _propTypes["default"].bool
};
Alert.defaultProps = {
  show: false
};
var _default = exports["default"] = Alert;